<div class="grid-x margin-top">
  <div class="cell large-12 medium-12 small-12 padding-left">
    <span class="h4 bold">
      Bonding Requirements for Stratigraphic Well
      @if (canEditBonding) {
        <span class="padding-left">
          <button (click)="openEditor(api)">
            <svg-icon class="small white" icon="icon-notepad"></svg-icon>
          </button>
        </span>
      }
    </span>
  </div>
  @if (showActiveBonding) {
    <div class="cell large-3 medium-3 small-6 padding-left padding-right text-align-right bold">
      Amount of Required Bonding:
    </div>
    <div class="cell large-2 medium-2 small-6 text-align-left">
      {{activeBondingRequirement?.amountRequired | currency: 'USD': 'symbol': '1.2-2' }}
    </div>
    <div class="cell large-2 medium-2 small-6 padding-left padding-right text-align-right bold">
      Bonding Required By:
    </div>
    <div class="cell large-3 medium-3 small-4">
      {{ activeBondingRequirement?.requiredBy |  date: 'longDate':'+0000' }}
    </div>
    <div class="cell large-2 medium-2 small-2">
      &nbsp;
    </div>
  } @else {
    <div class="cell large-12 medium-12 small-12">
      No active bonding requirements for this stratigraphic well.
    </div>
  }
  @if (showBondingHistory) {
    @if (loadingContacts == false) {
      <div class="cell large-6 medium-6 small-6 bold text-align-center bold">
        Changes to required bonding for this well:
      </div>
      <div class="cell large-6 medium-6 small-6 text-align-left padding-left">
        An <svg-icon class="tiny red" icon="icon-alert"></svg-icon> indicates a bonding requirement is pending and has not yet been saved.
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Amount
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Required By
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Effective From
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Effective To
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Entered By
      </div>
      <div class="cell large-2 medium-2 small-2 bold text-align-center">
        Entered On
      </div>
      @for (history of bondingRequirementHistory; track history) {
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{history.amountRequired | currency: 'USD': 'symbol': '1.2-2' }}
          <span class="padding-left">
            @if (history?.isPending) {
              <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
            }
          </span>
          <span class="padding-left">
            @if (history?.isPending) {
              <svg-icon class="tiny" icon="icon-trash" (click)="deletePending(history)"></svg-icon>
            }
          </span>
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{ history.requiredBy |  date: 'MM/dd/yyyy':'+0000' }}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{ history.effectiveFrom |  date: 'MM/dd/yyyy':'+0000' }}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{ history.effectiveTo |  date: 'MM/dd/yyyy':'+0000' }}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{ getContactName(history.enteredBy) }}
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-center">
          {{ history.enteredOn |  date: 'MM/dd/yyyy':'+0000' }}
        </div>
      }
    } @else {
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="true" [text]="'Loading bonding requirements history ... please wait '" [tickType]="'.'" [interval]="1500"></text-loader>
      </div>
    }
  }
</div>



<stratigraphic-bonding-editor [currentRequirement]="activeBondingRequirement" (bondingRequirementsUpdated)="onBondingUpdated($event)"></stratigraphic-bonding-editor>